const isLocal = window.location.hostname === 'localhost2'

export default {
  'check-user': (isLocal) ? '/check-user.json' : '/check-user',
  // COMMON
  'common': (isLocal) ? '/common.json' : '/common',
  // HOME
  'home': (isLocal) ? '/home.json' : '/home',
  // CONTACT
  'contact-list': (isLocal) ? '/contact-list.json' : '/contact-list',
  'contact-detail': (isLocal) ? '/contact-detail.json' : '/contact-detail',
  'contact-groups': (isLocal) ? '/contact-groups.json' : '/contact-groups',
  'contact-groups-detail': (isLocal) ? '/contact-groups-detail.json' : '/contact-groups-detail',
  // DOCUMENTS
  'documents': (isLocal) ? '/documents.json' : '/documents',
  // CALENDAR
  'calendar': (isLocal) ? '/calendar.json' : '/calendar',
  'calendar-detail': (isLocal) ? '/calendar-detail.json' : '/event-detail',
  // PROFILE
  'profile': (isLocal) ? '/profile.json' : '/profile',
  // HOLIDAYS
  'holidays': (isLocal) ? '/holidays.json' : '/holidays',
  'holidays-overview': (isLocal) ? '/holidays-overview.json' : '/holidays-overview',
  // TRAVELS
  'travels': (isLocal) ? '/travels.json' : '/travels',
  'travels-overview': (isLocal) ? '/travels-overview.json' : '/travels-overview',
  // REMOTE WORKING
  'remote-working': (isLocal) ? '/remote-working.json' : '/remote-working',
  'remote-working-overview': (isLocal) ? '/remote-working-overview.json' : '/remote-working-overview',
  // SEARCH
  'search': (isLocal) ? '/search.json' : '/search',

  // CONTENT PAGE
  'croplife-structure': (isLocal) ? '/croplife-structure.json' : '/croplife-structure',
  'priorities': (isLocal) ? '/priorities.json' : '/priorities',
  'toolbox': (isLocal) ? '/toolbox.json' : '/toolbox',
  'quick-links': (isLocal) ? '/quick-links.json' : '/quick-links',
  'coming-to-brussels': (isLocal) ? '/coming-to-brussels.json' : '/coming-to-brussels',
  'page': (isLocal) ? '/page.json' : '/page',

  // FROM FILTERS
  'filters-users': (isLocal) ? '/filters-users.json' : '/filters/users',
  'filters-groups': (isLocal) ? '/filters-groups.json' : '/filters/groups',
  'filters-documents': (isLocal) ? '/filters-documents.json' : '/filters/documents',
  'filters-events': (isLocal) ? '/filters-events.json' : '/filters/events',
  'filters-past-events': (isLocal) ? '/filters-past-events.json' : '/filters/past-events',
  'filters-upcoming-events': (isLocal) ? '/filters-upcoming-events.json' : '/filters/upcoming-events',
  'filters-calendar': (isLocal) ? '/filters-calendar.json' : '/filters/calendar',
  'filters-pages': (isLocal) ? '/filters-pages.json' : '/filters/pages',

  // POST
  'export-contact-list': (isLocal) ? '/export-contact-list.json' : '/export-contact-list',
  'export-all-contact-list': (isLocal) ? '/export-contact-list.json' : '/export-all-contact-list',
  'export-ics': (isLocal) ? '/export-ics.json' : '/export-ics',
  'calendar-detail-status': (isLocal) ? '/calendar-detail-status.json' : '/calendar-detail-status',
  'bookmark-document': (isLocal) ? '/bookmark.json' : '/bookmark',
  'my-new-data': (isLocal) ? '/my-new-data.json' : '/my-new-data',
  'login': (isLocal) ? '/login.json' : '/login',
  'holidays-request': (isLocal) ? '/holidays-request.json' : '/holidays-request',
  'travels-request': (isLocal) ? '/travels-request.json' : '/travels-request',
  'remote-working-request': (isLocal) ? '/remote-working-request.json' : '/remote-working-request',
  'profile-personal': (isLocal) ? '/profile-personal.json' : '/profile-personal',
  'profile-subscriptions': (isLocal) ? '/profile-subscriptions.json' : '/profile-subscriptions',

  /*

  */
  'lost-password': (isLocal) ? '/lost-password.json' : '/password/email',
  // email:
  // password:
  // password_confirmation:
  // token : URL TOKEN
  'new-password': (isLocal) ? '/new-password.json' : '/password/reset',
  'logout': (isLocal) ? '/logout.json' : '/logout'
}
